import CircleIcon from "@mui/icons-material/Circle";

interface Props {
    status: "normal" | "moistureAlert" | "cropAlert";
}

export const StatusIndicator: React.FC<Props> = ({status}) => (
    <CircleIcon
        sx={{
            stroke: status === "moistureAlert" ? "#EF6154" : status === "cropAlert" ? "#FEB24C" : "#E9EBF1",
            fill: status === "moistureAlert" ? "#F67A6D" : status === "cropAlert" ? "#FED976" : "#F3F5FA",
            width: "1rem",
            height: "1rem",
        }}
    />
);
